import STBButton from "@storeblocks/button";
import { StyledRow } from "App/global-style";
import styled from "styled-components";

interface ButtonWrapperProps {
  isOnColoredBackground?: boolean;
}

export const ButtonWrapper = styled(StyledRow)<ButtonWrapperProps>`
  align-items: center;
  display: flex;
  justify-content: center;
  padding-top: ${({ theme }) => theme.spacing.xs};
  width: 100%;

  a {
    color: ${({ theme }) => theme.buttons.color};

    :hover {
      background: transparent;
      color: ${({ theme }) => theme.buttons.color};
    }
  }
`;

export const Button = styled(STBButton)`
  &:hover,
  &:active,
  &:focus {
    background-color: transparent;

    & > span {
      text-decoration: underline;
    }
  }
`;
